import { useState, useCallback, useEffect } from 'react';
import { useProductStore } from '../../../../store/useProduct';
import { useLoginStore } from '../../../../store/useLogin';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPowerOff } from '@fortawesome/free-solid-svg-icons';

/**
 * @author taulmax
 * @createDate 2024.10.30
 * @description 상품 상세 페이지 - 서비스
 */
const PDButtonWrapper = () => {
  const navigate = useNavigate();
  const { role } = useLoginStore();
  const { productDetail, activeProduct } = useProductStore();

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const onChangeChecked = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(prev => !prev);
      try {
        const confirmYn = e.target.checked ? 'Y' : 'N';
        await activeProduct(productDetail?.id as string, confirmYn);
      } catch (error) {
        console.error('Failed to update product', error);
        setIsChecked(checked => !checked);
      }
    },
    [productDetail?.id, activeProduct]
  );

  useEffect(() => {
    if (productDetail?.confirmYn) {
      setIsChecked(productDetail.confirmYn === 'Y' ? true : false);
    }
  }, [productDetail?.confirmYn]);

  // 수정 버튼은 어드민만 보이고 어드민만 사용 가능 (USER/MARKETING은 숨김)
  if (role === 'ROLE_USER' || role === 'ROLE_MARKETING') {
    return <></>;
  }

  if (!productDetail?.confirmYn) {
    return (
      <div className="animate-pulse flex justify-between items-center">
        <div className="h-8 w-36 bg-gray-200 rounded"></div>
        <div className="h-8 w-24 bg-gray-200 rounded"></div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={isChecked}
          onChange={onChangeChecked}
        />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
        <span className={`ml-2 text-sm ${isChecked ? 'text-green-600 font-medium' : 'text-gray-500'}`}>
          {isChecked ? '활성화' : '비활성화'}
        </span>
      </label>
      
      <button
        onClick={() => navigate(`/product/update/${productDetail.id}`)}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-sm font-medium"
      >
        상품 수정
      </button>
    </div>
  );
};

export default PDButtonWrapper;
